/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} All_EventsInputs */



/**
* | output |
* | --- |
* | "All events" |
*
* @param {All_EventsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const all_events = /** @type {((inputs?: All_EventsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<All_EventsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tous les événements")
	if (locale === "de") return /** @type {LocalizedString} */ ("Alle Ereignisse")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tutti gli eventi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Все события")
	if (locale === "es") return /** @type {LocalizedString} */ ("Todos los eventos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("所有事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("すべてのイベント")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सभी इवेंट")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Todos os eventos")
	return /** @type {LocalizedString} */ ("All events")
});